import React from 'react'

const Music = () => {
    return(
        <div>
            Here we will build music block
        </div>
    )
}

export default Music;